const isAppleTouch = () => {
  const ua = navigator.userAgent || "";
  const iOS = /iPad|iPhone|iPod/.test(ua);
  // iPadOS Safari reports itself as a Mac, so fall back to touch points
  const iPadOnMacUA = ua.includes("Macintosh") && (navigator.maxTouchPoints || 0) > 1;
  return iOS || iPadOnMacUA;
};

const isAndroid = () => /Android/i.test(navigator.userAgent || "");

const standalone = () =>
  window.matchMedia?.("(display-mode: standalone)")?.matches ||
  window.navigator.standalone === true;

// On a phone, tablet or installed app: hand the chat straight to the WhatsApp app via its own
// scheme in the SAME tab (a new tab makes iOS render WhatsApp Web instead), then fall back to
// the wa.me web link if the app never takes over.
export const openWhatsApp = ({ url, app_url: appUrl }) => {
  const web = url;
  const app = appUrl || url;
  if (!web && !app) return;

  if (!isAppleTouch() && !isAndroid() && !standalone()) {
    window.open(web, "_blank", "noopener");
    return;
  }

  let handedOver = false;
  const markHandedOver = () => {
    handedOver = true;
  };
  document.addEventListener("visibilitychange", markHandedOver, { once: true });
  window.addEventListener("pagehide", markHandedOver, { once: true });

  window.location.href = app;

  window.setTimeout(() => {
    document.removeEventListener("visibilitychange", markHandedOver);
    window.removeEventListener("pagehide", markHandedOver);
    if (!handedOver && document.visibilityState === "visible" && web) {
      window.location.href = web;
    }
  }, 1600);
};
